import React from 'react'

const IconAutorun = ({ width = '48', height = '40' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(0.000000, -7.000000)">
        <path
          d="M21,23 C22.1045695,23 23,23.8954305 23,25 L23,47 L7,47 L7,23 L21,23 Z M21,28 L9,28 L9,45 L21,45 L21,28 Z M48,7 L48,37 L25,37 L25,35 L46,35 L46,9 L2,9 L2,35 L5,35 L5,37 L0,37 L0,7 L48,7 Z M18,25 L12,25 L12,26 L18,26 L18,25 Z M22,19 C24.6887547,19 26.8818181,21.1223067 26.9953805,23.7831104 L27,24 L25,24 C25,22.4023191 23.75108,21.0963391 22.1762728,21.0050927 L22,21 L22,19 Z M22,15 C26.8818027,15 30.8557914,18.8868137 30.9961629,23.7346377 L31,24 L29,24 C29,20.2145483 25.9952166,17.1309013 22.2406498,17.004059 L22,17 L22,15 Z M22,11 C29.0771346,11 34.8334283,16.6551918 34.9964496,23.6931438 L35,24 L33,24 C33,18.0212984 28.2302364,13.1566348 22.2884075,13.0037074 L22,13 L22,11 Z"
          fill="currentColor"
          fillRule="nonzero"
        />
        <g transform="translate(22.000000, 8.000000)" />
      </g>
    </g>
  </svg>
)

export default IconAutorun
